module.exports = __webpack_public_path__ + "static/img/2.8df68cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimages/2.png
// module id = aXJa
// module chunks = 1